export class MockCheckApi {
  static isSetLocalHost(config: any) {
    const mockApi: Array<string> = [];
    if (mockApi.some(item => item.includes(config.url))) {
      config.baseURL = "http://localhost:3000";
    }
  }
}
